import dayjs from 'dayjs';

const getDay = (date: Date | string | undefined): number => dayjs(date).date();

export { getDay };
